module.exports = __webpack_public_path__ + "img/fswap.b3f571e2.svg";